
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiChartSymbolizedBoundariesIec as ObiChartSymbolizedBoundariesIecElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-chart-symbolized-boundaries-iec.js';
 
 
 

 
 export const ObiChartSymbolizedBoundariesIec = createComponent({
   react: React,
   tagName: 'obi-chart-symbolized-boundaries-iec',
   elementClass: ObiChartSymbolizedBoundariesIecElement,
   events: {
     
   }
  });
 
 